/**
 * Groups recipients by their category (to, cc, bcc)
 * @param {Array} recipients - Array of recipient objects
 * @returns {Object} - Object with recipients grouped by category
 */
export const groupRecipientsByCategory = (recipients = []) =>
  recipients.reduce((acc, recipient) => {
    const category = recipient.category || "to";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(recipient);
    return acc;
  }, {});

/**
 * Gets CC recipients addresses from email recipients
 * @param {Array} recipients - Array of recipient objects
 * @returns {Array} - Array of CC recipient addresses
 */
export const getCcRecipientAddresses = (recipients = []) => {
  const grouped = groupRecipientsByCategory(recipients);
  return grouped.cc?.map((r) => r.recipient_address) || [];
};

/**
 * Gets BCC recipients addresses from email recipients
 * @param {Array} recipients - Array of recipient objects
 * @returns {Array} - Array of BCC recipient addresses
 */
export const getBccRecipientAddresses = (recipients = []) => {
  const grouped = groupRecipientsByCategory(recipients);
  return grouped.bcc?.map((r) => r.recipient_address) || [];
};
